import { TransferBaseRequestDto } from './transfer-base-request.dto';

export class ExternalTransferHeadersRequestDto extends TransferBaseRequestDto {
	public loggingStyle: string;
	public sstnLoggingStyle: string;
	public businessUnit: string;
	public drillHole: string;
	public surfaceSample: string;
	public standalone: string;
	public registeredDevices: string;

	public constructor(parameters: Partial<ExternalTransferHeadersRequestDto>) {
		super({
			AuthenticationMethod: parameters.AuthenticationMethod,
			Environment: parameters.Environment
		});

		this.loggingStyle = parameters.loggingStyle;
		this.sstnLoggingStyle = parameters.sstnLoggingStyle;
		this.businessUnit = parameters.businessUnit;
		this.drillHole = parameters.drillHole;
		this.surfaceSample = parameters.surfaceSample;
		this.standalone = parameters.standalone;
		this.registeredDevices = parameters.registeredDevices;
	}
}
